import { render, staticRenderFns } from "./PasswordProtect.vue?vue&type=template&id=bab5115e&scoped=true&"
import script from "./PasswordProtect.vue?vue&type=script&lang=js&"
export * from "./PasswordProtect.vue?vue&type=script&lang=js&"
import style0 from "./PasswordProtect.vue?vue&type=style&index=0&id=bab5115e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab5115e",
  null
  
)

export default component.exports